// Lably owns eligibility; normalize its rendered labels, without guessing tags,
// changing app configuration or touching the unrelated fixed-overlay stack.
export function syncProviderBadges(scope) {
  const rail = scope.querySelector('[data-tbwl-badges]');
  const destination = rail?.querySelector('[data-provider-badges]');
  if (!destination) return;
  const labels = new Map();
  for (const source of scope.querySelectorAll('._lably_item_, [data-lably-placement][data-id]')) {
    if (source.closest('[data-tbwl-badge-scope]') !== scope) continue;
    const text = source.textContent.trim();
    if (!text) continue; // Image-only provider labels stay provider-owned.
    if (!source.classList.contains('tbwl-provider-badge-source')) source.classList.add('tbwl-provider-badge-source');
    if (rail.dataset.available !== 'true') continue;
    const ready = /^ready to ship$/i.test(text);
    labels.set(source.dataset.id || text, {text:ready ? rail.dataset.readyLabel : text, ready});
  }
  const values = [...labels.values()].sort((a,b)=>Number(b.ready)-Number(a.ready) || a.text.localeCompare(b.text));
  const signature = JSON.stringify(values);
  if (destination.dataset.labels === signature) return;
  destination.dataset.labels = signature;
  destination.replaceChildren(...values.map(value => {
    const label = document.createElement('span');
    label.className = 'tbwl-badge'; label.dataset.badge = value.ready ? 'ready' : 'provider';
    label.textContent = value.text;
    return label;
  }));
}
// Provider widgets mutate the page frequently. Only revisit affected product
// scopes, and ignore our own output, rather than rescanning every card each time.
export function affectedBadgeScopes(records) {
  const scopes = new Set();
  for (const record of records) {
    const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (target?.closest('[data-provider-badges]')) continue;
    const parent = target?.closest('[data-tbwl-badge-scope]');
    if (parent) scopes.add(parent);
    for (const node of record.addedNodes || []) {
      if (node.nodeType !== 1) continue;
      if (node.matches('[data-tbwl-badge-scope]')) scopes.add(node);
      node.querySelectorAll('[data-tbwl-badge-scope]').forEach(scope => scopes.add(scope));
    }
  }
  return scopes;
}
if (typeof document !== 'undefined') {
  let queued = false;
  const pending = new Set();
  const refresh = scopes => {
    scopes.forEach(scope => pending.add(scope));
    if (!pending.size) return;
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      const scopes = [...pending];
      pending.clear();
      scopes.filter(scope => scope.isConnected).forEach(syncProviderBadges);
    });
  };
  new MutationObserver(records => refresh(affectedBadgeScopes(records))).observe(document.documentElement, {subtree:true,childList:true,characterData:true});
  refresh(document.querySelectorAll('[data-tbwl-badge-scope]'));
}
